import { lazy } from "react";
// project imports
import MainLayout from "layout/MainLayout";
import Loadable from "ui-component/Loadable";
import PurchaseHistory from "views/utilities/PurchaseHistory/PurchaseHistory";
import ViewPurchaseHistory from "views/utilities/PurchaseHistory/ViewPurchaseHistory";
import { Protected, ProtectedStaff } from "utils/common.utils";
import { getUserLocal } from "utils/localStorage.util";
import AuthGuard from "utils/route-guard/AuthGuard";
const userDetails = getUserLocal(); //User Role Access Routes

// dashboard routing
const Dashboard = Loadable(lazy(() => import("views/dashboard/Default/index")));
const FranchiseDashboard = Loadable(lazy(() => import("views/dashboard/Default/franhciseIndex")));

const InchargeDashboard = Loadable(lazy(() => import("views/dashboard/Default/inchargeIndex")));

const InchargeUnder = Loadable(lazy(() => import("views/utilities/InchargePanel/Under-lncharge")));

const InchargeCommsission = Loadable(
  lazy(() => import("views/utilities/InchargePanel/Commission-History"))
);

const DspInventory = Loadable(
  lazy(() => import("views/utilities/dsp/DspInventory"))
);
const DspTokens = Loadable(
  lazy(() => import("views/utilities/dsp/DspTokens"))
);
const JoiningKitPage = Loadable(
  lazy(() => import("views/utilities/incharge/joiningKit/JoiningKitPage"))
);
const AdminJoiningKits = Loadable(
  lazy(() => import("views/utilities/JoiningKit/AdminJoiningKits"))
);


// utilities routing
const Users = Loadable(lazy(() => import("views/utilities/users/users")));
const FrenchiseUsers = Loadable(lazy(() => import("views/utilities/users/franchiseUser")));

const ViewUsers = Loadable(lazy(() => import("views/utilities/users/view-user")));

// incentive routing
const IncentiveManagement = Loadable(
  lazy(() => import("views/utilities/incentive/IncentiveManagement"))
);

// banner routing
const Banner = Loadable(lazy(() => import("views/utilities/Banner/banner")));
const AddBanner = Loadable(lazy(() => import("views/utilities/Banner/add-banner")));
const EditBanner = Loadable(lazy(() => import("views/utilities/Banner/edit-banner")));

// category routing
const Category = Loadable(lazy(() => import("views/utilities/category/category")));
const AddCategory = Loadable(lazy(() => import("views/utilities/category/add-category")));
const EditCategory = Loadable(lazy(() => import("views/utilities/category/edit-category")));
const ViewCategory = Loadable(lazy(() => import("views/utilities/category/view-category")));

// product Routes
const Product = Loadable(lazy(() => import("views/utilities/product/Product")));
const ViewProduct = Loadable(lazy(() => import("views/utilities/product/view-product")));
const AddProduct = Loadable(lazy(() => import("views/utilities/product/add-product")));
const EditProduct = Loadable(lazy(() => import("views/utilities/product/edit-product")));

// inventory Routes
const Inventory = Loadable(lazy(() => import("views/utilities/inventory/inventory")));

// HRM Router
const Attenance = Loadable(lazy(() => import("views/utilities/HRM/attendance/attendence")));
const ViewAttedance = Loadable(
  lazy(() => import("views/utilities/HRM/attendance/view-attendence"))
);
const Holiday = Loadable(lazy(() => import("views/utilities/HRM/holiday/holiday")));
const AddHoliday = Loadable(lazy(() => import("views/utilities/HRM/holiday/add-holiday")));
const EditHoliday = Loadable(lazy(() => import("views/utilities/HRM/holiday/edit-holiday")));

// franchises routes
const FranchiseRequest = Loadable(
  lazy(() => import("views/utilities/Franchise/franchise-request"))
);
const FranchiseForm = Loadable(lazy(() => import("views/utilities/Franchise/franchise-form")));
const Franchise = Loadable(lazy(() => import("views/utilities/Franchise/franchise")));
const ViewFranchiseRequest = Loadable(
  lazy(() => import("views/utilities/Franchise/view-franchise-ruq"))
);
const EditFranchiseRequest = Loadable(
  lazy(() => import("views/utilities/Franchise/edit-franchise"))
);

// password routes
const ChangePassword = Loadable(
  lazy(() => import("views/utilities/change-password/change-password"))
);

// Manage area routes
const State = Loadable(lazy(() => import("views/utilities/manage-area/state/state")));

// Manage area routes
const EditState = Loadable(lazy(() => import("views/utilities/manage-area/state/edit-state")));
const AddState = Loadable(lazy(() => import("views/utilities/manage-area/state/add-state")));

// Manage area routes
const District = Loadable(lazy(() => import("views/utilities/manage-area/district/district")));
const EditDistrict = Loadable(
  lazy(() => import("views/utilities/manage-area/district/edit-district"))
);
const AddDistrict = Loadable(
  lazy(() => import("views/utilities/manage-area/district/add-district"))
);

// Manage area routes
const Block = Loadable(lazy(() => import("views/utilities/manage-area/block/block")));
const EditBlock = Loadable(lazy(() => import("views/utilities/manage-area/block/edit-block")));
const AddBlock = Loadable(lazy(() => import("views/utilities/manage-area/block/add-block")));

const Cluster = Loadable(lazy(() => import("views/utilities/manage-area/cluster/cluster")));
const EditCluster = Loadable(
  lazy(() => import("views/utilities/manage-area/cluster/edit-cluster"))
);
const AddCluster = Loadable(lazy(() => import("views/utilities/manage-area/cluster/add-cluster")));

// commission routes
const Commissiom = Loadable(lazy(() => import("views/utilities/commission/commission")));
const AddCommissiom = Loadable(lazy(() => import("views/utilities/commission/add-commission")));
const EditCommissiom = Loadable(lazy(() => import("views/utilities/commission/edit-commission")));

// application e-commerce pages
const AppECommProducts = Loadable(lazy(() => import("views/utilities/e-commerce/NewProduct")));
const AppECommProductDetails = Loadable(
  lazy(() => import("views/utilities/e-commerce/ProductDetails"))
);
const AppECommProductList = Loadable(lazy(() => import("views/utilities/e-commerce/ProductList")));
const AppECommCheckout = Loadable(lazy(() => import("views/utilities/e-commerce/Checkout")));

// subcategory routes
const SubCategory = Loadable(lazy(() => import("views/utilities/sub-category/subcategory")));
const AddSubCategory = Loadable(lazy(() => import("views/utilities/sub-category/add-subcategory")));
const EditSubCategory = Loadable(
  lazy(() => import("views/utilities/sub-category/edit-subcategory"))
);
const ViewSubCategory = Loadable(
  lazy(() => import("views/utilities/sub-category/view-subcategory"))
);

//Incharge routes
const FranchiseState = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseState/franchiseState"))
);
const AddFranchiseState = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseState/add-franchiseState"))
);
const PendingFranchiseState = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseState/pendingFranchiseState"))
);

const EditFranchiseDivision = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseDivision/edit"))
);
const AcceptDivisionDetail = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseDivision/Accept"))
);
const PendingDivision = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseDivision/pending"))
);
const AddDivisionFranchise = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseDivision/add"))
);

const EditFranchiseState = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseState/edit-franchiseState"))
);
const ViewFranchiseState = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseState/view-franchiseState"))
);
const ViewFranchiseDetail = Loadable(
  lazy(() => import("views/utilities/Franchise/view-frenchise"))
);

// Royalty Club routes
const RoyaltyClub = Loadable(
  lazy(() => import("views/utilities/incharge/royaltyClub"))
);

// block routes
const FranchiseBlock = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseBlock/franchiseBlock"))
);
const AddFranchiseBlock = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseBlock/add-franchiseBlock"))
);
const EditFranchiseBlock = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseBlock/edit-franchiseBlock"))
);
const PendingFranchiseBlock = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseBlock/pendingFranchiseBlock"))
);

// cluster routes
const FranchiseCluster = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseCluster/franchiseCluster"))
);
const AddFranchiseCluster = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseCluster/add-franchiseCluster"))
);
const EditFranchiseCluster = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseCluster/edit-franchiseCluster"))
);
const PendingFranchiseCluster = Loadable(
  lazy(
    () => import("views/utilities/incharge/franchiseCluster/pendingFranchiseCluster") //
  )
);

// ******* Village  routes
const FranchiseVillage = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseVillage/franchiseVillage"))
);
const AddFranchiseVillage = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseVillage/add-franchiseVillage"))
);
const EditFranchiseVillage = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseVillage/edit-franchiseVillage"))
);
const ViewFranchiseVillage = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseVillage/view-franchiseVillage"))
);
const PendingFranchiseVillage = Loadable(
  lazy(() => import("views/utilities/incharge/franchiseVillage/pendingFranchiseVillage"))
);

// Add Staff Franchise
const AddStaffFranchise = Loadable(
  lazy(() => import("views/utilities/incharge/addFranchiseStaff"))
);
const NetworkTree = Loadable(
  lazy(() => import("views/utilities/incharge/networkTree"))
);
//ledger

const Ledger = Loadable(lazy(() => import("views/utilities/Transaction History/transaction")));

const FranchiseLedger = Loadable(
  lazy(() => import("views/utilities/Transaction History/franchiseTransactionHistory"))
);

const CommissionHistory = Loadable(
  lazy(() => import("views/utilities/commision-history/commission-history"))
);

const CommissionDetail = Loadable(
  lazy(() => import("views/utilities/commision-history/commission-history-detail"))
);
// order history by farmer

const CompleteOrder = Loadable(
  lazy(() => import("views/utilities/order-history/farmer-Order-History/completeOrderByFarmer"))
);



const ViewLedger = Loadable(lazy(() => import("views/utilities/ledger/leadger-history")));

const ViewLedgerDetail = Loadable(lazy(() => import("views/utilities/ledger/ledger-detail")));
// order history by Franchise

const FPendingOrderHistory = Loadable(
  lazy(() =>
    import("views/utilities/order-history/franchise-Order-History/pendingOrderHistoryByFranchise")
  )
);


const WeeklySettlementHistory = Loadable(
  lazy(() => import("views/utilities/commision-history/weekly-settlement"))
);

const SettlementDetail = Loadable(
  lazy(() => import("views/utilities/commision-history/settlement-detail"))
);
const UserOrderDetail = Loadable(
  lazy(() => import("views/utilities/order-history/user-order-cart-detail"))
);
const GetFranchisOrder = Loadable(lazy(() => import("views/utilities/Franchise/orderFranchise")));

const FranchiseOrderDetail = Loadable(
  lazy(() => import("views/utilities/order-history/franchise-order-cart-detail"))
);

const FranchiseViewOrderDetail = Loadable(
  lazy(() => import("views/utilities/order-history/franchise-view-order-cart-detail"))
);

const FranchiseUserOnline = Loadable(
  lazy(() => import("views/utilities/franchiseOrder/OnlineOrderByFarmer"))
);

const FranchiseUserCOD = Loadable(
  lazy(() => import("views/utilities/franchiseOrder/CODOrderByFarmer"))
);
const OrderSuccess = Loadable(lazy(() => import("views/utilities/order-history/order-success")));

const UpdateInventory = Loadable(lazy(() => import("views/utilities/inventory/update-inventory")));

const FCompleteOrder = Loadable(
  lazy(() => import("views/utilities/order-history/franchise-Order-History/completeOrderFranchise"))
);

const FViewOrder = Loadable(
  lazy(() => import("views/utilities/order-history/farmer-Order-History/viewPendingOrder"))
);

// ***********             Company Routes       ***********

const AddCompany = Loadable(lazy(() => import("views/utilities/Company/add-company")));

const EditCompany = Loadable(lazy(() => import("views/utilities/Company/edit-company")));

const ViewCompany = Loadable(lazy(() => import("views/utilities/Company/view-company")));

const ViewCompanyHistory = Loadable(lazy(() => import("views/utilities/Company/company-history")));

const Page404 = Loadable(lazy(() => import("views/utilities/404")));

//Lead
const ViewContactUsLead = Loadable(lazy(() => import("views/utilities/Lead/contactLead")));

// my card
const MyCard = Loadable(lazy(() => import("views/utilities/myCard")));
// sample page routing
// ==============================|| MAIN ROUTING ||============================== //

const MainRoutes = {
  path: "/",
  element: (
    <AuthGuard>
      <MainLayout />
    </AuthGuard>
  ),
  children: [
    {
      path: "*",
      element: <Page404 />,
    },
    {
      path: "/dashboard",
      element: (
        <Protected isLoggedIn={userDetails}>
          <Dashboard />
        </Protected>
      ),
    },
    {
      path: "/franchiDashboard",
      element: <InchargeDashboard />,
    },
    {
      path: "/my-card",
      element: <MyCard />,
    },
    {
      path: "/inchargeDashboard",
      element: <InchargeDashboard />,
    },
    {
      path: "/joining-kit",
      element: <JoiningKitPage />,
    },
    {
      path: "/admin/joining-kits",
      element: <AdminJoiningKits />,
    },
    {
      path: "/joining-kits-manage",
      element: <AdminJoiningKits />,
    },
    {
      path: "/underIncharge",
      element: <InchargeUnder />,
    },
    {
      path: "/inchargeCommission",
      element: <InchargeCommsission />,
    },
    {
      path: "/dsp-inventory",
      element: <DspInventory />,
    },
    {
      path: "/dsp-tokens",
      element: <DspTokens />,
    },
    {
      path: "/incharge-tree",
      element: (
        <ProtectedStaff isLoggedIn={userDetails}>
          <NetworkTree />
        </ProtectedStaff>
      ),
    },
    {
      path: "/network-tree",
      element: (
        <ProtectedStaff isLoggedIn={userDetails}>
          <NetworkTree />
        </ProtectedStaff>
      ),
    },
    {
      path: "/transaction-history",
      element: (
        <Protected isLoggedIn={userDetails}>
          <Ledger />
        </Protected>
      ),
    },
    {
      path: "/update-inventory",
      element: (
        <Protected isLoggedIn={userDetails}>
          <UpdateInventory />
        </Protected>
      ),
    },
    {
      path: "/franchise-transaction-history",
      element: <FranchiseLedger />,
    },
    {
      path: "/commission-history",
      element: (
        <Protected isLoggedIn={userDetails}>
          <CommissionHistory />
        </Protected>
      ),
    },
    {
      path: "/add-field-officer-promotion",
      element: <AddStaffFranchise />,
    },
    {
      path: "/complete-order-by-farmer",
      element: <CompleteOrder />,
    },
    {
      path: "/pending-order-by-franchise",
      element: <FPendingOrderHistory />,
    },
    {
      path: "/complete-order-by-franchise",
      element: <FCompleteOrder />,
    },
    {
      path: "/view-order-franchise",
      element: <FViewOrder />,
    },
    {
      path: "user-order-details/:id",
      element: <UserOrderDetail />,
    },
    {
      path: "franchise-order-details/:id",
      element: <FranchiseOrderDetail />,
    },
    {
      path: "franchise-view-order-details/:id",
      element: <FranchiseViewOrderDetail />,
    },
    {
      path: "view-contact-lead",
      element: <ViewContactUsLead />,
    },
    {
      path: "weekly-settlement",
      element: (
        <Protected isLoggedIn={userDetails}>
          <WeeklySettlementHistory />
        </Protected>
      ),
    },

    {
      path: "settlementDetail/:id",
      element: <SettlementDetail />,
    },
    {
      path: "payment-success/:id",
      element: <OrderSuccess />,
    },
    {
      path: "/e-commerce/products",
      element: <AppECommProducts />,
    },
    {
      path: "/e-commerce/product-details/:id",
      element: <AppECommProductDetails />,
    },
    {
      path: "/e-commerce/product-list",
      element: <AppECommProductList />,
    },
    {
      path: "/e-commerce/checkout",
      element: <AppECommCheckout />,
    },

    {
      path: "/inventory",
      element: <Inventory />,
    },
    {
      path: "/ledger",
      element: <ViewLedger />,
    },
    {
      path: "ledgerDetail/:id/:name",
      element: <ViewLedgerDetail />,
    },
    {
      children: [
        {
          path: "commission",
          element: <Commissiom />,
        },
        {
          path: "add-commission",
          element: <AddCommissiom />,
        },
        {
          path: "edit-commission/:id",
          element: <EditCommissiom />,
        },
      ],
    },
    {
      children: [
        {
          path: "add-company",
          element: (
            <Protected isLoggedIn={userDetails}>
              <AddCompany />
            </Protected>
          ),
        },
        {
          path: "view-company-history",
          element: (
            <Protected isLoggedIn={userDetails}>
              <ViewCompanyHistory />
            </Protected>
          ),
        },
        {
          path: "edit-company/:id",
          element: <EditCompany />,
        },
        {
          path: "view-company/:id",
          element: (
            <Protected isLoggedIn={userDetails}>
              <ViewCompany />
            </Protected>
          ),
        },
      ],
    },
    {
      children: [
        {
          path: "sub-category",
          element: (
            <Protected isLoggedIn={userDetails}>
              <SubCategory />
            </Protected>
          ),
        },
        {
          path: "add-subcategory",
          element: (
            <Protected isLoggedIn={userDetails}>
              <AddSubCategory />
            </Protected>
          ),
        },
        {
          path: "edit-subcategory/:id",
          element: <EditSubCategory />,
        },
        {
          path: "view-subcategory/:id",
          element: (
            <Protected isLoggedIn={userDetails}>
              <ViewSubCategory />
            </Protected>
          ),
        },
      ],
    },
    {
      children: [
        {
          path: "banner",
          element: <Banner />,
        },
        {
          path: "add-banner",
          element: <AddBanner />,
        },
        {
          path: "edit-banner/:id",
          element: <EditBanner />,
        },
      ],
    },
    {
      children: [
        {
          path: "incentives",
          element: (
            <ProtectedStaff isLoggedIn={userDetails}>
              <IncentiveManagement />
            </ProtectedStaff>
          ),
        },
        {
          path: "admin/incentives",
          element: (
            <ProtectedStaff isLoggedIn={userDetails}>
              <IncentiveManagement />
            </ProtectedStaff>
          ),
        },
      ],
    },
    {
      children: [
        {
          path: "purchase-history",
          element: (
            <Protected isLoggedIn={userDetails}>
              <PurchaseHistory />
            </Protected>
          ),
        },
        {
          path: "view-purchase-history/:id",
          element: <ViewPurchaseHistory />,
        },
        {
          path: "/view-commission-detail/:id",
          element: <CommissionDetail />,
        },
      ],
    },
    {
      children: [
        {
          path: "franchise",
          element: (
            <Protected isLoggedIn={userDetails}>
              <Franchise />
            </Protected>
          ),
        },
        {
          path: "franchise-request-form",
          element: <FranchiseForm />,
        },
        {
          path: "franchise-request",
          element: (
            <Protected isLoggedIn={userDetails}>
              <FranchiseRequest />
            </Protected>
          ),
        },
        {
          path: "view-franchise-request/:id",
          element: <ViewFranchiseRequest />,
        },
        {
          path: "edit-franchise-request/:id",
          element: <EditFranchiseRequest />,
        },
        {
          path: "/view-franchise/:id",
          element: <ViewFranchiseDetail />,
        },
        {
          path: "franchise-order",
          element: <GetFranchisOrder />,
        },
        {
          path: "franchise-user-online",
          element: <FranchiseUserOnline />,
        },
        {
          path: "franchise-user-cod",
          element: <FranchiseUserCOD />,
        },
      ],
    },
    {
      children: [
        {
          path: "franchise-state",
          element: (
            <Protected isLoggedIn={userDetails}>
              <FranchiseState />
            </Protected>
          ),
        },
        {
          path: "add-franchise-state",
          element: (
            <Protected isLoggedIn={userDetails}>
              <AddFranchiseState />
            </Protected>
          ),
        },
        {
          path: "pending-request-state-incharge",
          element: (
            <Protected isLoggedIn={userDetails}>
              <PendingFranchiseState />
            </Protected>
          ),
        },
        {
          path: "edit-franchise-state/:id",
          element: <EditFranchiseState />,
        },
        {
          path: "view-franchise-state/:id",
          element: (
            <Protected isLoggedIn={userDetails}>
              <ViewFranchiseState />
            </Protected>
          ),
        },
        {
          path: "add-division",
          element: (
            <Protected isLoggedIn={userDetails}>
              <AddDivisionFranchise />
            </Protected>
          ),
        },
        {
          path: "edit-division/:id",
          element: <EditFranchiseDivision />,
        },
        {
          path: "accept-division",
          element: (
            <Protected isLoggedIn={userDetails}>
              <AcceptDivisionDetail />
            </Protected>
          ),
        },
        {
          path: "pending-division",
          element: (
            <Protected isLoggedIn={userDetails}>
              <PendingDivision />
            </Protected>
          ),
        },
        {
          path: "royalty-club",
          element: <RoyaltyClub />,
        },
        {
          path: "franchise-block",
          element: <FranchiseBlock />,
        },
        {
          path: "add-franchise-block",
          element: <AddFranchiseBlock />,
        },
        {
          path: "/pending-request-block-incharge",
          element: <PendingFranchiseBlock />,
        },
        {
          path: "edit-franchise-block/:id",
          element: <EditFranchiseBlock />,
        },
        {
          path: "franchise-cluster",
          element: <FranchiseCluster />,
        },
        {
          path: "add-franchise-cluster",
          element: <AddFranchiseCluster />,
        },
        {
          path: "/pending-request-Cluster-incharge",
          element: <PendingFranchiseCluster />,
        },
        {
          path: "edit-franchise-cluster/:id",
          element: <EditFranchiseCluster />,
        },
        {
          path: "franchise-village",
          element: <FranchiseVillage />,
        },
        {
          path: "add-franchise-village",
          element: <AddFranchiseVillage />,
        },
        {
          path: "view-franchise-village/:id",
          element: <ViewFranchiseVillage />,
        },
        {
          path: "edit-franchise-village/:id",
          element: <EditFranchiseVillage />,
        },
        {
          path: "pending-village",
          element: <PendingFranchiseVillage />,
        },
        {
          path: "incharge-tree",
          element: (
            <ProtectedStaff isLoggedIn={userDetails}>
              <NetworkTree />
            </ProtectedStaff>
          ),
        },
      ],
    },
    {
      children: [
        {
          path: "state",
          element: <State />,
        },
        {
          path: "edit-state/:id",
          element: <EditState />,
        },
        {
          path: "add-state",
          element: <AddState />,
        },
        // district
        {
          path: "district",
          element: <District />,
        },
        {
          path: "edit-district/:id",
          element: <EditDistrict />,
        },
        {
          path: "add-district",
          element: <AddDistrict />,
        },
        // zip code
        {
          path: "block",
          element: <Block />,
        },
        {
          path: "edit-block/:id",
          element: <EditBlock />,
        },
        {
          path: "add-block",
          element: <AddBlock />,
        },
        {
          path: "cluster",
          element: <Cluster />,
        },
        {
          path: "edit-cluster/:id",
          element: <EditCluster />,
        },
        {
          path: "add-cluster",
          element: <AddCluster />,
        },
      ],
    },
    {
      children: [
        {
          path: "frenchise-users",
          element: <FrenchiseUsers />,
        },
        {
          path: "users",
          element: <Users />,
        },
        {
          path: "view-user/:id",
          element: <ViewUsers />,
        },
      ],
    },
    {
      children: [
        {
          path: "change-passwrd",
          element: <ChangePassword />,
        },
      ],
    },
    {
      children: [
        {
          path: "category",
          element: <Category />,
        },
        {
          path: "add-category",
          element: <AddCategory />,
        },
        {
          path: "edit-category/:id",
          element: <EditCategory />,
        },
        {
          path: "view-category/:id",
          element: <ViewCategory />,
        },
      ],
    },
    {
      children: [
        {
          path: "product",
          element: <Product />,
        },
        {
          path: "add-product",
          element: <AddProduct />,
        },
        {
          path: "edit-product/:id",
          element: <EditProduct />,
        },
        {
          path: "view-product/:id",
          element: <ViewProduct />,
        },
      ],
    },
    {
      children: [
        {
          path: "attedance",
          element: <Attenance />,
        },
        {
          path: "view-attendence",
          element: <ViewAttedance />,
        },
      ],
    },
    {
      children: [
        {
          path: "holidays",
          element: <Holiday />,
        },
        {
          path: "add-holiday",
          element: <AddHoliday />,
        },
        {
          path: "edit-holiday/:id",
          element: <EditHoliday />,
        },
      ],
    },
  ],
};

export default MainRoutes;
